import { ComparisonOperator } from "./comparison-operator";
import { UriPart } from "./uri";

export interface IFormLeftOperandInfo {
  name?: string | UriPart;
  operators: ComparisonOperator[];
}
export interface IFormLeftOperand {
  id?: string;
  name: UriPart;
  type: string;
}

export const FORM_COMPARISON_LEFT_OPERANDS = {
  url: {
    name: "Full URL",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
    ],
  },
  protocol: {
    name: "Protocol",
    operators: [
      ComparisonOperator.equals,
    ],
  },
  domain: {
    name: "Domain",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
    ],
  },
  path: {
    name: "Path",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
    ],
  },
  query: {
    name: "Query String",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
      // ComparisonOperator.populated,
    ],
  },
  hash: {
    name: "Hash",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
      // ComparisonOperator.populated,
    ],
  },
  paramkey: {
    name: "Parameter Key",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
    ],
  },
  paramvalue: {
    name: "Parameter Value",
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
      // ComparisonOperator.populated,
    ],
  },
  option: {
    operators: [
      ComparisonOperator.contains,
      ComparisonOperator.equals,
      ComparisonOperator.startsWith,
      ComparisonOperator.endsWith,
      ComparisonOperator.matchesRegex,
      // ComparisonOperator.populated,
    ],
  },
};

export const FORM_COMPARISON_LEFT_OPERAND_OPTION = "option";
